import React, { useState, useRef, useEffect } from 'react';
import { Download, FileText, FileJson, ChevronDown } from 'lucide-react';
import { downloadJSON, printPDF } from '../utils/downloadUtils';

const DownloadButton = ({ report, url }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDownload = (type) => {
    setIsOpen(false);
    
    if (type === 'pdf') {
      printPDF(report, url);
    } else if (type === 'json') {
      downloadJSON(report, url);
    }
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
      >
        <Download className="w-4 h-4 mr-2" />
        Download Report
        <ChevronDown className={`w-4 h-4 ml-2 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-50">
          <div className="py-1">
            <button
              onClick={() => handleDownload('pdf')}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <FileText className="w-4 h-4 mr-3 text-red-500" />
              PDF (via printer)
            </button>
            <button
              onClick={() => handleDownload('json')}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
            >
              <FileJson className="w-4 h-4 mr-3 text-blue-500" />
              JSON feed
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadButton;
